import { render, staticRenderFns } from "./GroupUpdate.vue?vue&type=template&id=8b4169ac&"
import script from "./GroupUpdate.vue?vue&type=script&lang=ts&"
export * from "./GroupUpdate.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports